import React, { Component } from 'react';
import DashboardTableWidget from '../../2/Controls/DashboardTableWidget';

class WidgetMachineDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: false
    };
  }

  componentDidMount() {
    const { stores } = this.props;
    this.loadData(stores);
  }

  componentDidUpdate(prevProps) {
    const { stores } = this.props;
    if (prevProps.stores !== stores) {
      this.loadData(stores);
    }
  }

  handleRowClick = (row) => {
    const { history } = this.props;

    history.push({
      pathname: '/report',
      search: '?name=MachineTracker',
      state: {
        filters: {
          sku: row.productSKU,
        }
      }
    });
  };

  onColumClick = (productSku,status) => {
    const { history } = this.props;

    history.push({
      pathname: '/report',
      search: '?name=MachineTracker',
      state: {
        filters: {
          sku: productSku,
          searchStatus:status
        }
      }
    });
  };

  loadData = async (stores) => {
    const { getMachineDashboardCount } = this.props;

    if (!stores || stores.length === 0) {
      this.setState({ data: [] });
      return;
    }

    this.setState({ loading: true });
    try {
      const uniqueStores = stores
        .filter(store => store.key && store.key.trim() !== "")
        .filter((store, index, self) =>
          index === self.findIndex(s => s.key === store.key)
        );
      const result = await getMachineDashboardCount(uniqueStores);
      this.setState({
        data: result.data || [],
        loading: false
      });
    } catch (error) {
      console.error('Error loading data:', error);
      this.setState({
        data: [],
        loading: false
      });
    }
  };

  handleViewMore = () => {
    console.log('View More clicked');
  };

  // Custom renderer for product name with SKU
  renderProductWithSKU = (row) => {
    return (
      <div   onClick={()=>{this.onColumClick(row.productSKU,"all")}}>
        <div style={{ fontWeight: '500',cursor:'pointer' }}>{row.productName || '-'}</div>
        <div style={{ fontSize: '12px', color: '#666' }}>{row.productSKU || '-'}</div>
      </div>
    );
  };
  renderInstockQty = (row) => {
    return (
      <div>
        <a   style={{ cursor: 'pointer' }} onClick={()=>{this.onColumClick(row.productSKU,"Instock")}}>
          {row.inStockQty || '0'}
        </a>
      </div>
    );
  };
  renderDemoQty = (row) => {
    return (
      <div>
               <a   style={{ cursor: 'pointer' }} onClick={()=>{this.onColumClick(row.productSKU,"Demo")}}>
          {row.demoQty || '0'}
        </a>
      </div>
    );
  };
  renderCustomerQty = (row) => {
    return (
      <div>
           <a   style={{ cursor: 'pointer' }} onClick={()=>{this.onColumClick(row.productSKU,"Customer")}}>
          {row.customerQty || '0'}
        </a>
      </div>
    );
  };
  renderReturnForServicingQty = (row) => {
    return (
      <div>
          <a   style={{ cursor: 'pointer' }} onClick={()=>{this.onColumClick(row.productSKU,"Return for servicing")}}>
          {row.returnForServicingQty || '0'}
        </a>
      </div>
    );
  };
  render() {
    const { data, loading } = this.state;

    // Define columns for the table
    const columns = [
      { key: 'productImage[0].ImagePath', label: 'Image', type: "image" },
      {
        key: 'productName',
        label: 'Product',
        // Use custom renderer instead of the default
        render: this.renderProductWithSKU
      },
      {
        key: 'inStockQty', label: 'InStock',
        render: this.renderInstockQty
      },
      { key: 'demoQty', label: 'Demo', render: this.renderDemoQty },
      { key: 'customerQty', label: 'Customer', render: this.renderCustomerQty },
      { key: 'returnForServicingQty', label: 'Return for servicing', render: this.renderReturnForServicingQty },
      { key: 'openTicket', label: 'Open Ticket',type:"number" }
    ];

    return (
      <DashboardTableWidget
        title="Machine Dashboard"
        data={data}
        columns={columns}
        // onRowClick={this.handleRowClick}
        loading={loading}
      />
    );
  }
}

export default WidgetMachineDashboard;